import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Back } from "../../assets/svgs/icons";
import { LogoDefault } from "../../assets/svgs/logos";
import AirHeader from "../../components/AirHeader";
import { MyContext } from "../../context/MyContext";
import useMyActivityView from "../myActivityV2/hooks/useMyActivityView";
import { SubscriptionCompleteStyled } from "./styled";
import { BillingProduct } from "./utils";

interface SubscriptionCompleteState {
  orderId?: string;
}

const SubscriptionComplete = () => {
  const { isMobile, setOpenNav } = useContext(MyContext);
  const { handleGoBack } = useMyActivityView();
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state as SubscriptionCompleteState) || {};

  const [selectedProduct, setSelectedProduct] = useState<BillingProduct | null>(
    null,
  );

  // sessionStorage에서 selectedProduct 가져오기 (Sparrow #8953223)
  useEffect(() => {
    const storedProduct = sessionStorage.getItem("selectedProduct");
    if (storedProduct) {
      try {
        setSelectedProduct(JSON.parse(storedProduct));
      } catch (error) {
        console.error("sessionStorage 파싱 오류:", error);
      }
    }
  }, []);

  const { orderId = "GPA.1234-5678-9012-34567" } = state;

  const productTitle = selectedProduct?.title || "";
  const price = selectedProduct?.price || "";
  const trialPeriodDays = selectedProduct?.trialPeriodDays || "";
  const billingPeriodDays = selectedProduct?.billingPeriodDays || "";
  const nextPaymentDay = selectedProduct?.nextPaymentDay || "";

  return (
    <div className="flex flex-row h-full w-full bg-white overflow-hidden">
      <div className="flex-1 flex flex-col min-h-0 overflow-hidden relative">
        {isMobile ? (
          <AirHeader type="sub" title="구독 완료" />
        ) : (
          <header className="relative flex items-center justify-center bg-white w-full h-[64px] shrink-0">
            {/* Back Button */}
            <button
              onClick={handleGoBack}
              className="absolute left-0 top-1/2 -translate-y-1/2 p-4"
              aria-label="뒤로가기"
            >
              <Back className="w-6 h-6 text-[#212121]" />
            </button>

            {/* Logo */}
            <LogoDefault className="w-[100px] h-[25px]" />
          </header>
        )}

        <div className="content overflow-y-auto min-h-0">
          <SubscriptionCompleteStyled.Container>
            <div className="title-area">
              <div className="img">
                <div className="main-img">
                  <img
                    alt="Subscription Complete"
                    src="https://img.dongascience.com/air/sub_complete_air.png"
                  />
                  <div className="check-img">
                    <img
                      alt="Check Icon"
                      src="https://img.dongascience.com/air/28_checkIcon.png"
                    />
                  </div>
                </div>
              </div>
              <h3>구독이 완료되었습니다!</h3>
              <div className="desc">
                환영합니다! 이제 모든 기능을 이용하실 수 있습니다.
              </div>
            </div>
            <div className="product-area">
              <span className="badge">구독 상품</span>
              <div className="product-title">{productTitle}</div>
              <div className="price">{price}</div>
              <div className="sub">
                <div className="kv">
                  <span>이용기간</span>
                  <span>{trialPeriodDays || billingPeriodDays || "-"}</span>
                </div>
                <div className="kv purple">
                  <span>다음 결제일</span>
                  <span>{nextPaymentDay || "-"}</span>
                </div>
                <div className="kv">
                  <span>결제처</span>
                  <span>Google Play</span>
                </div>
                <div className="kv">
                  <span>구글 결제번호</span>
                  <span>{orderId}</span>
                </div>
              </div>
            </div>
            <div className="desc-area">
              🎉 지금 바로 튜터 소크라테스와 함께 <br />
              학습을 시작해보세요!
            </div>
            <button
              className="gradient-btn"
              onClick={() => {
                navigate("/tutor", { state: { forceClose: true } });
              }}
            >
              시작하기
            </button>
          </SubscriptionCompleteStyled.Container>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionComplete;
